import styled from 'styled-components';
import styles from '../../utility/styles';

export default styled.div`
    background-color: ${styles.colors.darkGray};
    border-radius: 8px;
    padding: 16px;
`